import { render, staticRenderFns } from "./ResetFilterHandler.vue?vue&type=template&id=70524b76"
import script from "./ResetFilterHandler.vue?vue&type=script&lang=ts"
export * from "./ResetFilterHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports